<template>
<div class="chapter">
<div class="inner_page">
<div class="frontmatter" title="101 Things to Do With Canned Biscuits">
<div class="verso">
<p class="versotitle">101 Things to Do With Canned Biscuits</p>
<p>Digital Edition v1.0</p>
<p>Text © 2010 Toni Patrick</p>
<p>All rights reserved. No part of this book may be reproduced by any means
                    whatsoever without written permission from the publisher, except brief portions
                    quoted for purpose of review.</p>
<p class="nobreak">Gibbs Smith, Publisher</p>
<p class="nobreak">PO Box 667</p>
<p>Layton, UT 84041</p>
<p class="nobreak">Orders: 1.800.835.4993</p>
<p>www.gibbs-smith.com</p>
<p>Library of Congress Catalog-in-Publishing Data</p>
<p class="nobreak">ISBN-13: 978-1-4236-0463-1</p>
<p class="nobreak">ISBN-10: 1-4236-0463-6</p>
<p class="nobreak">1. Biscuits. I. Title. II. Title: One hundred one things to do
                    with canned biscuits. III. Title: One hundred and one things to do with canned
                    biscuits.</p>
<p class="nobreak">TX770.B55P38 2008</p>
<p class="nobreak">641.8'15—dc22</p>
<p class="nobreak">2008000114</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// verso.vue?3ae3ae43